// TODO enable toggleOpenClass animation on triggers, buttons, togglebars, parents

// Utilities
import debug from "debug";
const MODULE_NAME = 'toggle';
const log = debug(MODULE_NAME);

//	lodash components
import pickby from 'lodash/pickBy';
import pick from 'lodash/pick';
import identity from 'lodash/identity';
import groupby from 'lodash/groupBy';
import find from 'lodash/find';
import map from 'lodash/map';

//	browser tests
import { cssTransitions } from '../../services/browser-features';

//
// Constants
// ===========
const TOGGLEBAR_DATA_ATTR = 'toggle-togglebar';
const PANEL_DATA_ATTR = 'toggle-panel';
// const PARENT_DATA_ATTR = 'toggle-parent';	//	TODO: currently unused - should be?
const TRIGGER_DATA_ATTR = 'toggle-trigger';

//	Default class parts
const CLOSE_CLASS_PREFIX = 'is-toggled-closed-';
const OPEN_CLASS_PREFIX = 'is-toggled-open-';

//	Button classes
const BUTTON_CLASS = 'toggle-button';
const BUTTON_ICON_CLASS = 'icon icon-icon_arrow-down toggle-button-icon';
const BUTTON_ARIA_LABEL = 'details';

//
//	Shared
// ===========
let loneGroups = {};

//
// Functions
// ===========
var dataSelector = function(attrName){
	return '[data-' + attrName + ']';
};

var panelId = function(parts){
	var prefix = ['toggle_panel'];
	return prefix.concat(parts).join('_');
};

var capitaliseFirstLetter = function(string) {
	return string.length && string.charAt(0).toUpperCase() + string.slice(1);
};

var onTransitionEnd = function(panel, event){

	//	Ignore bubbled events
	if (event.target !== panel.element) {
		return true;
	}

	log(event.type, this.isClosed ? 'closed' : 'open');

	if (this.isClosed) {

		$(panel.element).addClass(panel.toggleCloseClass);

	}

	doFocus.call(this, panel);
};

var doFocus = function(panel){

	if (!this.isClosed && panel.toggleOpenFocus) {

		window.setTimeout(function(){
			document.getElementById(panel.toggleOpenFocus).focus();
		}, 0);

	} else if (this.isClosed && panel.toggleCloseFocus) {

		window.setTimeout(function(){
			document.getElementById(panel.toggleCloseFocus).focus();
		}, 0);

	}
};

var togglePanel = function(panel){

	if (this.isClosed) {
		log('closing');

		//	Only animate if configured to
		if (!cssTransitions || !panel.toggleAnimate) {
			log('closing without animation');

			$(panel.element).addClass(panel.toggleCloseClass);

		} else {

			log('waiting for transitionend to close');

		}

	} else {
		log('opening');

		//	panel is opening
		$(panel.element).removeClass(panel.toggleCloseClass);

	}

	doFocus.call(this, panel);

	//	Defer triggering transition to give browser chance to
	//	establish a new transition start position
	//noinspection MagicNumberJS
	window.setTimeout(function(){
		$(panel.element).toggleClass(panel.toggleOpenClass);
	}, 20);
};

//	Called bound to group object
var toggleGroup = function () {

	this.isClosed = !this.isClosed;

	if (this.togglebar) {
		$(this.togglebar.element).toggleClass(this.togglebar.toggleCloseClass);
	}

	//	For each trigger
	if (this.triggers) {

		this.triggers.forEach(function(trigger){
			var $trigger = $(trigger.element);
			$trigger
				.attr('aria-expanded', $trigger.attr('aria-expanded') === 'false')
				.toggleClass(trigger.toggleCloseClass);
		});

	}

	if (this.panels) {

		this.panels.forEach(togglePanel.bind(this));

	}

	if (this.parent) {

		$(this.parent.element).toggleClass(this.parent.toggleCloseClass);

	}

	//	if contained is opening
	if (this.container && !this.isClosed) {

		//	Ensure container opens too
		if (this.container.isClosed) {

			toggleGroup.call(this.container);

		}
	}

	//	Presumes contained groups responsible for their own opening.
	//	If container is closing
	if (this.containsGroups && this.isClosed) {

		//	Toggle contained open groups
		this.containsGroups.filter(function (group) {
			return !group.isClosed;
		}).forEach(function(group){
			toggleGroup.call(group);
		});

	}

};

//	Presumes buttons are hidden if not appropriate to click
//	Therefore no media test or lone logic
// var handleButtonClick = toggleGroup;


var isOpen = function(group){
	return !group.isClosed;
};

var handleTriggerClick = function (triggerObj, event) {

	const media = triggerObj.toggleMedia;

	//	Ensure script does not interfere with modifier clicks
	if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ) {
		return true;
	}

	//	Prevent trigger closing own panels – tab behaviour
	if (this.panels && (this.panels[0].toggleCloseSelf === false && !this.isClosed)) {
		return true;
	}

	if (!media || media && Foundation.MediaQuery.atLeast(media) ) {

		event.preventDefault();
		event.stopPropagation();

		//	Toggle untoggled groups with same lone value
		if (this.lone && triggerObj.toggleIgnoreLone !== true) {

			loneGroups[this.lone]
				.filter(function(group){
					return this !== group;
				},this)
				.filter(isOpen)
				.forEach(function(group){
					toggleGroup.call(group);
				});
		}

		//	Group may have a trigger with no panel
		//	toggles fellow lone groups only (above)
		if (this.panels) {
			toggleGroup.call(this);
		}
	}

};


var hasPanel = function(group){
	return group.panels && group.panels.length !== 0;
};

//	Fetch only defined data attributes
var pickToggleData = function(data){
	var props = [
		'toggleInitClass',
		'toggleCloseClass',
		'toggleOpenClass',
		'toggleLone',
		'toggleIgnoreLone',
		'toggleParentElement',
		'toggleMedia',
		'toggleAnimate',
		'toggleButtonClass',
		'toggleOpenFocus',
		'toggleCloseFocus',
		'toggleCloseSelf',
		'toggleContains'
	];
	return pick(data, props);
};


//  Default properties for: panel, trigger, togglebar
//	group name is derived from value of type attr
//	data-toggle-panel="group_name"
//	data-toggle-trigger="group_name"
var pickToggleType = function(data, type){

	var newData = {
		group: data['toggle' + capitaliseFirstLetter(type)],
		toggleCloseClass: CLOSE_CLASS_PREFIX + type,
		toggleOpenClass: OPEN_CLASS_PREFIX + type,
		toggleButtonClass: BUTTON_CLASS
	};

	//	Filter out group if falsey
	return pickby(newData, identity);
};

//	Presence of toggleCloseClass on a toggle panel element upon init
//	Determines open/closed state of toggle group
//	Animating open class is added to panel by js on init
//	State classes set on elements other than panel on init

var buildObj = function(dataAttr, type){
	// note jQuery().map() arg order differs from array.prototype.map
	return function(index,element){
		var data = $(element).data();
		return $.extend(
			{
				toggleInitClass: '',
				element: element,
				type: type
			},
			pickToggleType(data, type),
			pickToggleData(data)
		);
	};
};

var buildParentObj = function(element, selector){

	if (!selector) {
		return false;
	}

	var $parent = $(element).closest(selector);

	if (!$parent.length) {
		return false;
	}

	var data = $parent.data();
	var defaults = {
		toggleInitClass: '',
		toggleCloseClass: CLOSE_CLASS_PREFIX + 'parent',
		element: $parent.get(),
		type: 'parent'
	};
	return data ? $.extend(
			defaults,
			pickToggleData(data)
		) : defaults;
};

var buildGroup = function buildGroup(groupSet, key){

	var collect = groupby(groupSet, function(item){
		return item.type;
	});

	var lonePanel = find(collect.panel, 'toggleLone');
	var loneTrigger = find(collect.trigger, 'toggleLone');

	var group = {
		panels: collect.panel,
		triggers: collect.trigger,
		isClosed: true,
		lone: lonePanel && lonePanel.toggleLone || loneTrigger && loneTrigger.toggleLone
	};

	//	if any panels have contains value
	const contains = collect.panel ? collect.panel.reduce(function (list, panel ) {
		if (panel.toggleContains) {

			return list.concat(panel.toggleContains.split(','));

		}
	},[]) : false;

	if (contains && contains.length) {
		group.contains = contains;
	}

	if (key) {
		group.id = key;
	}

	//	togglebars or triggers may have a parent
	//	togglebar parent overrides trigger parent
	if (collect.togglebar) {

		//	Expects only one togglebar
		group.togglebar = collect.togglebar[0];
		group.parent = buildParentObj(collect.togglebar[0].element, collect.togglebar[0].toggleParentElement);

	} else if (collect.trigger) {

		group.parent = buildParentObj(collect.trigger[0].element, collect.trigger[0].toggleParentElement);

	}


	if (key === 'search') log("group",group);

	return group;
};


//	DOM changes and event binding

const initPanels = function (group, isOpen) {
	//	Groups may contain panels or not
	if (!group.panels) {
		return false;
	}

	group.panels.forEach(function(panel, index){

		//	Generate panel element id of absent
		if (!panel.element.id) {

			panel.element.id = panelId([group.id, index]);

		}
		panel.id = panel.element.id;

		$(panel.element).addClass(panel.toggleInitClass);

		//	Add animate open class if open in markup
		if (!group.isClosed) {

			$(panel.element).addClass(panel.toggleOpenClass);
			$(panel.element).removeClass(panel.toggleCloseClass);

		} else {

			$(panel.element).addClass(panel.toggleCloseClass);

		}

		$(panel.element).on('transitionend', onTransitionEnd.bind(group, panel));

		//	Panel toggle class presumed present in markup
		//	...
	});
};

const initParent = function (group, isOpen) {
	if (!group.parent) {
		return false;
	}

	$(group.parent.element).addClass(group.parent.toggleInitClass);

	if (group.isClosed) {

		$(group.parent.element).addClass(group.parent.toggleCloseClass);

	}
};

const initToggleBar = function (group, isOpen) {
	if (!group.togglebar) {
		return false;
	}

	$(group.togglebar.element).addClass(group.togglebar.toggleInitClass);

	if (group.isClosed) {
		$(group.togglebar.element).addClass(group.togglebar.toggleCloseClass);
	}

	//	Button is inserted into togglebar with panel/s associated
	if (group.panels && group.panels.length) {

		// Search for existing button
		group.button = $('.' + group.togglebar.toggleButtonClass, group.togglebar.element);

		if (!group.button.length) {
			group.button = $('<button></button>', {
				type: 'button',
				'class': group.togglebar.toggleButtonClass
			});

			var buttonIcon = $('<i></i>', {
				'class': BUTTON_ICON_CLASS
			});

			group.button
				.append(buttonIcon)
				.appendTo(group.togglebar.element);
		}

		group.button.attr({
			//	TODO: redundant since the button has a hidden label?
			'aria-label': BUTTON_ARIA_LABEL
		});

		if (!group.triggers) {

			group.triggers = [];

		}

		// Add button to triggers
		var buttonTrigger = buildObj('', 'trigger')(0, group.button);
		group.triggers.push(buttonTrigger);
	}

};

const initTriggers = function (group, isOpen) {

	if (!group.triggers) {
		return false;
	}

	group.triggers.forEach(function (trigger, index) {
		const $element = $(trigger.element);

		const attr = {
			'aria-expanded': '' + isOpen
		};

		//	Trigger may not have panels of its own
		//	(Associated instead via lone to other groups)
		if (group.panels) {

			attr['aria-controls'] = group.panels.map(function(panel) {
					return panel.id;
				}).join(' ');

		}

		$element
			.attr(attr)
			.on('click', handleTriggerClick.bind(group, trigger));

		$element.addClass(trigger.toggleInitClass);

		if (!isOpen) {
			$element.addClass(trigger.toggleCloseClass);
		}
	});

};

const initGroup = function(group){

	//	Skip this group if already initialised
	if (group.isInitialised) { return false; }
	group.isInitialised = true;

	//
	//	Determine initial open state
	//	Closed by default
	let isClosed = false;

	//	Presence of panel close class overrides
	if (group.panels) {

		isClosed = $(group.panels[0].element).hasClass(group.panels[0].toggleCloseClass);

	}

	//	Group is closed if container is closed
	const isContained = !!group.container;
	const isContainerClosed = isContained && group.container.isClosed;
	const isOpen = isContainerClosed ? false : !isClosed;

	group.isClosed = !isOpen;

	initPanels(group, isOpen);
	initParent(group, isOpen);

	//	togglebars must be init before triggers
	//	it may add triggers to the group
	initToggleBar(group, isOpen);
	initTriggers(group, isOpen);

};

//
// Initialise
// ===========
export default function run (){

	log('Running…');

	//	Find togglebar
	var $togglebar = $(dataSelector(TOGGLEBAR_DATA_ATTR));
	var togglebar = $togglebar.map( buildObj(TOGGLEBAR_DATA_ATTR, 'togglebar') ).get();

	//	Find data-small-toggle-panel
	var $panels = $(dataSelector(PANEL_DATA_ATTR));
	var panels = $panels.map( buildObj(PANEL_DATA_ATTR, 'panel') ).get();

	var $triggers = $(dataSelector(TRIGGER_DATA_ATTR));
	var triggers = $triggers.map( buildObj(TRIGGER_DATA_ATTR, 'trigger') ).get();


	//	Abort if no panels found
	if (!panels.length) {

		log('No toggle panels found - bye');
		return false;
	}

	log('Panels found:', panels.length);

	var allGroups = panels.concat(togglebar,triggers);

	var sets = groupby(allGroups, function(item){
		return item.group;
	});

	//	using lodash because sets is an object
	var groups = map(sets, buildGroup);

	const containers = groups.filter(function(group){
		return group.contains;
	});

	//	Add references between containers and contained
	containers.forEach(function(container) {

		//	Find contained group objects
		const containedGroups = container.contains.reduce(function(groupsInside, groupId){
			const foundContained = groups.filter(function(group){
				return group.id === groupId;
			});
			return groupsInside.concat(foundContained);
		},[]);

		//	Amend contained groups with ref to their container
		containedGroups.forEach(function (group) {
			group.container = container;
		});

		//	Amend container groups with ref to the groups they contain
		container.containsGroups = containedGroups;

	});


	var getLone = function(group){
		return group.lone;
	};

	loneGroups = groupby(groups.filter(getLone), getLone);

	//	Init container groups first
	//	So their init state is available to contained groups upon init
	containers.forEach(initGroup);

	//	Init the rest
	groups.forEach(initGroup);

	log('…complete');
};



// WEBPACK FOOTER //
// ./project/client/src/core/modules/navigation/toggle.js